export default "__VITE_ASSET__DVPMp7ot__"